import { getTransferOrderById } from "./TransferOrderByIdAction"

const dispatchGetTransferOrderById = (dispatch: Function) => (val : any) => {
    dispatch(getTransferOrderById(val));
};

const OrderDispatch = {
    dispatchGetTransferOrderById
};

export default OrderDispatch